/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Learn_CorrectInputs */

const zh_learn_correct = /** @type {(inputs: Learn_CorrectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正确`)
};

const en_learn_correct = /** @type {(inputs: Learn_CorrectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Correct`)
};

const es_learn_correct = /** @type {(inputs: Learn_CorrectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Correcto`)
};

/**
* | output |
* | --- |
* | "Correct" |
*
* @param {Learn_CorrectInputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const learn_correct = /** @type {((inputs?: Learn_CorrectInputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Learn_CorrectInputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_learn_correct(inputs)
	if (locale === "en") return en_learn_correct(inputs)
	return es_learn_correct(inputs)
});